import apiClient from "../../../api/apiClient";

/**
 * Servicio para operaciones relacionadas con ofertas/bids
 */
class BidService {
  /**
   * Obtiene una oferta por su ID
   * @param {string|number} id - ID de la oferta
   * @returns {Promise<Object>} Datos de la oferta
   */
  async getBidById(id) {
    try {
      const data = await apiClient.get(`/api/ofertas/ofertaById/${id}`);
      return data[0]; // La API retorna un array con un elemento
    } catch (error) {
      throw error;
    }
  }

  /**
   * Redime noches de hotel
   * @param {Object} reservationData - Datos de la reserva
   * @param {Object} reservationData.user - Información del usuario
   * @param {number} reservationData.adultos - Número de adultos
   * @param {number} reservationData.ninos - Número de niños
   * @param {string} reservationData.fechasalida - Fecha de salida (check-in)
   * @param {string} reservationData.fecharegreso - Fecha de regreso (check-out)
   * @param {Object} reservationData.oferta - Información de la oferta
   * @param {string} reservationData.tipo - Tipo de oferta
   * @param {string} reservationData.edad_niños - Edades de los niños
   * @returns {Promise<string>} URL de la solicitud generada
   */
  async redeemNights(reservationData) {
    try {
      const {
        user,
        adultos,
        ninos,
        fechasalida,
        fecharegreso,
        oferta,
        tipo,
        edad_niños,
      } = reservationData;

      const payload = {
        contrato: user.contracto.contrato,
        hotel: oferta.titulo,
        fecha_llegada: fecharegreso,
        fecha_salida: fechasalida,
        adultos,
        niños: ninos,
        tipo,
        edad_niños,
      };

      const response = await apiClient.post(
        "/api/ofertas/redimir-noches",
        payload,
      );

      // Si hay error en la respuesta
      if (response?.err) {
        throw new Error("Error al procesar la solicitud");
      }

      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Valida una oferta
   * @param {string|number} id_cupon - ID del cupón/oferta
   * @param {string} contrato - Número de contrato
   * @returns {Promise<Object>} Resultado de la validación
   */
  async validateBid(id_cupon, contrato) {
    try {
      const payload = {
        contrato,
        id: parseInt(id_cupon),
      };

      const data = await apiClient.post("/api/ofertas/validaroferta", payload);
      return data;
    } catch (error) {
      throw error;
    }
  }
}

const bidService = new BidService();

export default bidService;
